export const environment = {
  production: true,
  api: window['env']['api'] === '${API_URL}' ? 'https://api.infosindical.sistemafaeg.org.br/rest' : window['env']['api'],
  searchApi: 'https://apitv.campolab.com.br/',
  apiLeiteBem: 'https://api-leitebem.sistemafaeg.com.br',
  oauthLeiteBem: 'https://id.sistemafaeg.org.br',
  apiPesebem: 'https://api-pesebem-adm.sistemafaeg.org.br/api/v1',
  talentos: 'https://api.talentosdocampo.com.br',
  cdn: ' https://cdn-v2.sistemafaeg.org.br/documents/',
  login: ' https://login.sistemafaeg.org.br',
  version: 'V 7.0.7',
};
